/**
 * External dependencies
 */

import { get, find, has } from 'lodash';

/**
 * Internal dependencies
 */
import { DEFAULT_PREFERENCE_VALUES } from './constants';

export const isFetchingPreferences = (state) => !!state.preferences.fetching;

export function getPreference(state, key) {
    return get(
        find([state.preferences.localValues, state.preferences.remoteValues, DEFAULT_PREFERENCE_VALUES], (source) =>
            has(source, key),
        ),
        key,
        null,
    );
}

export function getAllRemotePreferences(state) {
    return state.preferences.remoteValues;
}

export const preferencesLastFetchedTimestamp = (state) => state.preferences.lastFetchedTimestamp;

export function hasReceivedRemotePreferences(state) {
    return !!state.preferences.remoteValues;
}
